// ประเภทสัญญาทั้งหมดที่รองรับ
export const CONTRACT_TYPES = [
  "rpsl",
  "vsfhp",
  "sfhp",
  "lsfhp",
  "psfhp",
  "vsfhp_ksm",
  "tsfhp_ksm",
  "lsfhp_ksm",
];
